// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.abouttitle {
  width: 1200px;
  margin: 0px auto;
  padding: 20px 0px 40px 0px;
}
.abouttitle h2 {
  font-size: 50px;
  color: #f0f0f0;
  margin: 0px;
}
.abouttitle h3 {
  font-size: 36px;
  color: #333;
  margin: 0px;
  margin-top: -40px;
}
.abouttitle::after {
  content: '';
  height: 5px;
  width: 80px;
  display: inline-block;
  background: #4477de;
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutTitle/index.less"],"names":[],"mappings":"AAAA;EAAY,aAAA;EAAc,gBAAA;EAAiB,0BAAA;AAI3C;AAJA;EACM,eAAA;EAAiB,cAAA;EAAe,WAAA;AAQtC;AATA;EAEM,eAAA;EAAgB,WAAA;EAAY,WAAA;EAAY,iBAAA;AAa9C;AAVA;EAAmB,WAAA;EAAY,WAAA;EAAY,WAAA;EAAY,qBAAA;EAAuB,mBAAA;AAiB9E","sourcesContent":[".abouttitle{width:1200px; margin:0px auto; padding:20px 0px 40px 0px;\n   h2{font-size: 50px; color:#f0f0f0; margin:0px;}\n   h3{font-size:36px; color:#333; margin:0px; margin-top:-40px;}\n\n}\n.abouttitle::after{content:''; height:5px; width:80px; display: inline-block; background:#4477de;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
